import type { CSSProperties } from "react";

/**
 * Estilos tipográficos do Workbase DS (tokens `--woba-*`) usados no Painel.
 * Os tokens `heading-*` não publicam `font-size`, então usamos a escala
 * `--woba-typography-font-size-x*` (mesma escolha do Card do DS).
 */
const typographyStyle = (
  token: string,
  fontSize: string,
  color = "var(--woba-color-content-default)",
): CSSProperties => ({
  margin: 0,
  fontFamily: `var(--woba-typography-${token}-font-family)`,
  fontWeight: `var(--woba-typography-${token}-font-weight)`,
  fontSize,
  lineHeight: `var(--woba-typography-${token}-line-height)`,
  letterSpacing: `var(--woba-typography-${token}-letter-spacing)`,
  color,
});

const SUBTLE = "var(--woba-color-content-subtle)";

export const wobaText = {
  /** Heading/Large — título da página (32px). */
  headingLarge: typographyStyle(
    "heading-large",
    "var(--woba-typography-font-size-x8)",
  ),
  /** Heading/Medium — valor dentro do anel (24px). */
  headingMedium: typographyStyle(
    "heading-medium",
    "var(--woba-typography-font-size-x6)",
  ),
  /** Heading/Small — títulos de seção e de card (20px). */
  headingSmall: typographyStyle(
    "heading-small",
    "var(--woba-typography-font-size-x5)",
  ),
  /** Paragraph/Medium subtle — descrição de card (16px). */
  paragraphMedium: typographyStyle(
    "paragraph-medium",
    "var(--woba-typography-paragraph-medium-font-size)",
    SUBTLE,
  ),
  /** Caption/Medium subtle (14px). */
  captionMedium: typographyStyle(
    "caption-medium",
    "var(--woba-typography-caption-medium-font-size)",
    SUBTLE,
  ),
  /** Caption/Small (12px). */
  captionSmall: typographyStyle(
    "caption-small",
    "var(--woba-typography-caption-small-font-size)",
  ),
  /** Overline/Medium subtle, caixa alta (12px). */
  overlineMedium: {
    ...typographyStyle(
      "overline-medium",
      "var(--woba-typography-overline-medium-font-size)",
      SUBTLE,
    ),
    textTransform: "uppercase",
  },
  /** Label/Xsmall — rótulo de campo (14px, bold). */
  labelXsmall: typographyStyle(
    "label-xsmall",
    "var(--woba-typography-label-xsmall-font-size)",
  ),
  /** Label/Xlarge — valor de métrica (32px). */
  labelXlarge: typographyStyle(
    "label-xlarge",
    "var(--woba-typography-label-xlarge-font-size)",
  ),
} satisfies Record<string, CSSProperties>;
